import { SharingState } from '@/store/types';

const state: SharingState = {
  requestError: {
    get: {
      message: '',
    },
    post: {
      message: '',
    },
    put: {
      message: '',
    },
    delete: {
      message: '',
    },
  },
  invite: {
    email: '',
    state: '',
  },
  selected: {
    uuid: '',
    email: '',
    state: '',
    inviter: {
      uuid: '',
      name: '',
    },
    invitee: {
      uuid: '',
      name: '',
    },
  },
  table: {
    headers: [
      { text: 'Email', value: 'email', sortable: false, align: 'start' },
      { text: 'Status', value: 'state', sortable: false },
      { text: 'Remove', value: 'remove', sortable: false },
    ],
    invitations: [],
  },
};

export default state;
